import React, { useState, useEffect } from "react";
import { Text, StyleSheet, TouchableOpacity, Platform } from "react-native";

import AppTheme from "../../AppTheme";
import ManaHourMinutes from "../../common/ManaHourMinutes";

export default function StatsCardChartProgress({
  data,
  maxValue,
  showPercentage,
}) {
  const [showProgress, setShowProgress] = useState(true);

  useEffect(() => {
    setShowProgress(!!showPercentage);
  }, [showPercentage]);

  return (
    <TouchableOpacity
      onPress={() => setShowProgress(!showProgress)}
      style={[
        styles.bar,
        {
          alignItems: data.hours > 0 ? "flex-start" : "flex-end",
        },
      ]}
    >
      <Text
        style={[
          styles.hours,
          {
            justifyContent: data.hours > 0 ? "flex-start" : "flex-end",
            width: `${(Math.abs(data.progress) * 100) / maxValue}%`,
          },
        ]}
      >
        {data.progress > 0 ? "+" : ""}
        {showProgress ? (
          data.progress + "%"
        ) : (
          <ManaHourMinutes duration={data.hours} />
        )}
      </Text>
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  bar: {
    height: 40,
    flex: 1,
    borderLeftColor: AppTheme.borderColor,
    borderLeftWidth: 1,
    borderRightColor: AppTheme.borderColor,
    borderRightWidth: 1,
    justifyContent: "center",
  },
  hours: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
    backgroundColor: AppTheme.darkGray,
    height: 20,
    borderRadius: 4,
    paddingHorizontal: 4,
    display: "flex",
    alignItems: "center",
    minWidth: "20%",
  },
});
